import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wtime-modal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "wtime-modal--title" }, "Please confirm charge", -1)
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = { class: "wtime-modal--charge-total" }
const _hoisted_5 = {
  key: 0,
  class: "wtime-modal--expenses"
}
const _hoisted_6 = {
  key: 0,
  class: "wtime-modal--expenses_paid"
}
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "wtime-modal--title" }, "Add waiting time", -1)
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "wtime-modal--form" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Hours", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: null }, null, -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Minutes", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: null }, null, -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = { class: "wtime-modal--charge" }
const _hoisted_21 = {
  key: 0,
  class: "wtime-modal--expenses"
}
const _hoisted_22 = {
  key: 0,
  class: "wtime-modal--expenses_paid"
}

import BottomModal from '@/components/BottomModal.vue'
import { useWaitingTime } from '@/store/waiting-time'
import { ref, watchEffect, computed } from 'vue';
import { toastSuccess } from '@/store/toasts'
import { useConfirmDialog } from '@vueuse/core'
import type { BookingExtraExpense } from '@/models/your-bookings'


export default /*#__PURE__*/_defineComponent({
  __name: 'WaitingTimeModal',
  props: {
    show: { type: Boolean },
    bookingId: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
  bookingId: number;
};





const hoursList = [1, 2, 3, 4, 5, 6, 7, 8]
const minutesList = [15, 30, 45]

const expenses = ref<BookingExtraExpense[]>([])
const waitingHours = ref<number | null>(null)
const waitingMinutes = ref<number | null>(null)


const { saveWaitingTime, getWaitingTime, isPending, error, chargeError, isChargePending, chargeWaitingTime } = useWaitingTime(props.bookingId)

const { isRevealed: confirmModalVisible, reveal: showConfirmModal, cancel: hideConfirmModal } = useConfirmDialog()

const isSaveDisabled = computed(() => isPending.value || (!waitingHours.value && !waitingMinutes.value))
const isUnpaid = computed(() => expenses.value.filter(v => !v.isWaitingTimePaid).length > 0)

const onSave = async () => {
  if (waitingHours.value || waitingMinutes.value) {
    await saveWaitingTime({ hours: waitingHours.value, minutes: waitingMinutes.value })
    waitingHours.value = null
    waitingMinutes.value = null
    fetchExpenses()
  }
}

const onCharge = async () => {
  await chargeWaitingTime()
  hideConfirmModal()
  emit('close')
  toastSuccess('Successfully charged')
}

const fetchExpenses = async () => {
  expenses.value = await getWaitingTime()
}


watchEffect(() => {
  if (props.show) {
    fetchExpenses()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomModal, {
    size: "md",
    show: __props.show,
    onClose: _cache[5] || (_cache[5] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(confirmModalVisible))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2,
              (_unref(chargeError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(chargeError)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (expenses.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expenses.value, (v) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: v.id
                        }, [
                          _createTextVNode(_toDisplayString(v.description) + " x 1 ", 1),
                          (v.isWaitingTimePaid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Paid"))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                disabled: _unref(isChargePending),
                onClick: _withModifiers(onCharge, ["prevent"]),
                class: "btn btn-cancel btn-block confirm-job-modal--confirm-btn"
              }, " Yes, I confirm ", 8, _hoisted_7),
              _createElementVNode("button", {
                class: "btn btn-block btn-link",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(hideConfirmModal) && _unref(hideConfirmModal)(...args)), ["prevent"]))
              }, " Cancel ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_8,
              (_unref(error))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(error)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((waitingHours).value = $event)),
                    class: "form-control"
                  }, [
                    _hoisted_13,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(hoursList, (v) => {
                      return _createElementVNode("option", {
                        value: v,
                        key: v
                      }, _toDisplayString(v), 9, _hoisted_14)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, waitingHours.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((waitingMinutes).value = $event)),
                    class: "form-control"
                  }, [
                    _hoisted_17,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(minutesList, (v) => {
                      return _createElementVNode("option", {
                        value: v,
                        key: v
                      }, _toDisplayString(v), 9, _hoisted_18)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, waitingMinutes.value]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                disabled: _unref(isSaveDisabled),
                onClick: _withModifiers(onSave, ["prevent"]),
                class: "btn btn-cancel btn-block confirm-job-modal--confirm-btn"
              }, " Save ", 8, _hoisted_19),
              _createElementVNode("button", {
                class: "btn btn-block btn-link",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('close')), ["prevent"]))
              }, " Close "),
              _createElementVNode("div", _hoisted_20, [
                (expenses.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expenses.value, (v) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: v.id
                        }, [
                          _createTextVNode(_toDisplayString(v.description) + " x 1 ", 1),
                          (v.isWaitingTimePaid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Paid"))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isUnpaid))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-cancel btn-block confirm-job-modal--confirm-btn",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(showConfirmModal) && _unref(showConfirmModal)(...args)), ["prevent"]))
                    }, "Charge waiting time"))
                  : _createCommentVNode("", true)
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})